import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { Image } from "primereact/image";
import { useState } from "react";
import { helper } from "./utils/helper";
import { PrintOut } from "../pages/reports/PrintOut";
import GenericDocumentTable from "./GenericDocumentTable";
import GenericDocumentTableBuilder from "./GenericDocumentTableBuilder";

export default function ({ documents, setDocuments = () => { }, header, error = "", showAction = true, isGenericView }) {
	var [showPdf, setShowPdf] = useState(false);
	var [pdf, setPdf] = useState(null);
	const imageFormats = [
		"jpeg",
		"jpg",
		"png",
		"gif",
		"bmp",
		"tiff",
		"tif",
		"webp",
		"svg",
		"ico",
		"apng"
	];

	return (
		<>
			<GenericDocumentTableBuilder error={error} isGenericView={isGenericView} showAction={showAction} header={header} documents={documents} setDocuments={setDocuments} />
			<ConfirmPopup />
			{/* {pdf !== null && <PrintOut isReport={false} base64={pdf} setBase64={setPdf} showDialog={showPdf} setShowDialog={setShowPdf} />}
			<DataTable header={header} value={documents}>
				<Column field="title" header={"Document Name"} />

				{showAction && (<Column field="description" header={"Document Type"} />)}
				<Column
					field="preview"
					header="Preview"
					body={(row) => (
						<>
							{(helper.checkBase64Type(row.binaryData) === "img" || imageFormats.includes(row?.ext)) && (
								<Image preview width="50px" src={`${row.binaryData}`} />
							)}
							{(helper.checkBase64Type(row.binaryData) === "pdf" || row?.ext === "pdf") && (
								<span
									onClick={() => {
										setPdf(`${row.binaryData}`);
										setShowPdf(true);
									}}
									style={{ cursor: "pointer", display: "inline-block", width: "100px", objectFit: "cover" }}
								>
									<i className={PrimeIcons.FILE_PDF} style={{ fontSize: "16px", color: "red" }}></i> PDF
								</span>
							)}
						</>
					)}
				/>

				{showAction && (<Column
					header={"Action"}
					field="Action"
					body={(row, data) => (
						<Button
							style={{
								textAlign: "center",
								width: "30px",
								height: "30px"
							}}
							icon={"pi pi-trash"}
							className="p-button-danger p-button-rounded"
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								confirmPopup({
									target: e.currentTarget,
									message: "Are you sure you want to proceed?",
									icon: "pi pi-exclamation-triangle",
									defaultFocus: "accept",
									accept: () => {
										try {
											e?.preventDefault()
											e?.stopPropagation()
										} catch (error) {

										}
										var doc = documents.filter((_, index) => index !== data.rowIndex);
										setDocuments(doc);
									},
									reject: () => {
										try {
											e?.preventDefault()
											e?.stopPropagation()
										} catch (error) {

										}
									}
								});
							}}
						/>
					)}
				></Column>)}

			</DataTable> */}
		</>
	);
}
